import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="privacy-page">
      <header className="sticky top-0 z-40 jn-glass-strong">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" data-testid="privacy-logo-link">
            <Logo size="text-xl" />
          </Link>
          <Link
            to="/"
            className="jn-btn-ghost px-4 py-2 rounded-full text-xs inline-flex items-center gap-2"
            data-testid="privacy-back-link"
          >
            <ArrowLeft size={14} /> Terug naar home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-5">
          Privacy & cookies
        </div>
        <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tight">
          Privacyverklaring JYNOVA
        </h1>
        <p className="mt-4 text-sm text-zinc-500 font-body">
          Laatst bijgewerkt: december 2025
        </p>

        <div className="mt-12 space-y-10 font-body text-zinc-300 leading-relaxed">
          <Section title="1. Wie zijn wij?">
            <p>
              JYNOVA (hierna "wij", "ons") is een Belgisch merk gespecialiseerd
              in slimme oppervlakken: privacy smart film, display glass en
              smart wall panels. Voor vragen over deze verklaring kan je ons
              steeds bereiken via{" "}
              <a
                href="mailto:info@jynova.be"
                className="text-cyan-400 hover:underline"
              >
                info@jynova.be
              </a>
              .
            </p>
          </Section>

          <Section title="2. Welke gegevens verzamelen wij?">
            <p>
              We verwerken uitsluitend de gegevens die je zelf met ons deelt
              wanneer je het contact- of offerteformulier invult:
            </p>
            <ul className="mt-3 space-y-1.5 list-disc list-inside text-zinc-400">
              <li>Voor- en achternaam</li>
              <li>E-mailadres</li>
              <li>Telefoonnummer</li>
              <li>Gemeente</li>
              <li>Type klant (particulier / bedrijf)</li>
              <li>Gewenste oplossing en geschatte afmetingen</li>
              <li>Optioneel: bericht en/of foto van de ruimte</li>
            </ul>
            <p className="mt-3">
              Daarnaast houden wij geen gedragsprofielen bij en gebruiken we
              geen marketing- of trackingcookies.
            </p>
          </Section>

          <Section title="3. Waarvoor gebruiken wij je gegevens?">
            <ul className="space-y-1.5 list-disc list-inside text-zinc-400">
              <li>
                Om contact met je op te nemen en een prijsinschatting op maat
                te bezorgen.
              </li>
              <li>
                Om je aanvraag administratief te verwerken en op te volgen.
              </li>
              <li>
                Om — uitsluitend op jouw vraag — een afspraak of plaatsing in
                te plannen.
              </li>
            </ul>
            <p className="mt-3">
              We sturen je geen ongevraagde commerciële berichten en we
              verkopen je gegevens nooit aan derden.
            </p>
          </Section>

          <Section title="4. Op welke grondslag?">
            <p>
              De verwerking gebeurt op basis van jouw{" "}
              <span className="text-white">toestemming</span> (artikel 6.1.a
              GDPR) wanneer je het formulier verstuurt, en/of op basis van de{" "}
              <span className="text-white">
                uitvoering van een overeenkomst
              </span>{" "}
              (artikel 6.1.b GDPR) wanneer we op je vraag een offerte of
              installatie verzorgen.
            </p>
          </Section>

          <Section title="5. Hoe lang bewaren wij je gegevens?">
            <p>
              Aanvragen die niet leiden tot een offerte of opdracht worden
              maximaal 12 maanden bewaard. Gegevens van klanten met wie we een
              opdracht uitvoeren, worden bewaard zolang als nodig om aan onze
              wettelijke verplichtingen te voldoen (o.a. fiscale bewaarplicht
              van 7 jaar).
            </p>
          </Section>

          <Section title="6. Met wie delen wij je gegevens?">
            <p>
              Je gegevens worden uitsluitend gedeeld met onze technische
              dienstverleners die nodig zijn om de website en e-mail te laten
              werken (o.a. hosting en e-mailbezorging). Met al deze partijen
              hebben wij verwerkersovereenkomsten en zij verwerken je gegevens
              uitsluitend in onze opdracht.
            </p>
          </Section>

          <Section title="7. Cookies">
            <p>
              We gebruiken enkel essentiële, functionele cookies die nodig
              zijn om de website correct te tonen (o.a. om je
              cookievoorkeur op te slaan). We plaatsen{" "}
              <span className="text-white">geen</span> tracking-,
              advertentie- of analytics-cookies.
            </p>
          </Section>

          <Section title="8. Jouw rechten">
            <p>
              Je hebt steeds het recht om je gegevens in te zien, te laten
              corrigeren of te laten verwijderen, je toestemming in te
              trekken, en bezwaar te maken tegen de verwerking. Stuur hiervoor
              een e-mail naar{" "}
              <a
                href="mailto:info@jynova.be"
                className="text-cyan-400 hover:underline"
              >
                info@jynova.be
              </a>
              . Je hebt ook altijd het recht om klacht in te dienen bij de
              Belgische Gegevensbeschermingsautoriteit (
              <a
                href="https://www.gegevensbeschermingsautoriteit.be"
                target="_blank"
                rel="noreferrer"
                className="text-cyan-400 hover:underline"
              >
                gegevensbeschermingsautoriteit.be
              </a>
              ).
            </p>
          </Section>

          <Section title="9. Wijzigingen">
            <p>
              We kunnen deze verklaring van tijd tot tijd aanpassen. De meest
              recente versie vind je steeds op deze pagina.
            </p>
          </Section>

          <div className="pt-6 border-t border-white/10 text-sm text-zinc-500">
            Heb je vragen of wens je je rechten uit te oefenen? Neem contact
            op via{" "}
            <a
              href="mailto:info@jynova.be"
              className="text-cyan-400 hover:underline"
            >
              info@jynova.be
            </a>
            .
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-2xl md:text-3xl text-white font-medium tracking-tight mb-4">
        {title}
      </h2>
      <div className="text-base text-zinc-300">{children}</div>
    </section>
  );
}
